import { render } from "./AlbumCard.vue?vue&type=template&id=a312e77c&scoped=true"
import script from "./AlbumCard.vue?vue&type=script&lang=js"
export * from "./AlbumCard.vue?vue&type=script&lang=js"

import "./AlbumCard.vue?vue&type=style&index=0&id=a312e77c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a312e77c"]])

export default __exports__